export function readFileAsync(file: any, asText: boolean = false) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = reject;
        if (asText) {
            reader.readAsText(file);
        }else{
            reader.readAsArrayBuffer(file);
        }
    })
}